import { Button } from "@material-ui/core";
import React from "react";
import { goTo } from "../../Helpers/history";
import { Routes } from '../Router/routes';

export const RegisterButton = () => (
    <Button color="inherit" onMouseUp={_ => goTo(Routes.Pages.Register)} size="small">
        Регистрация
    </Button>
);